import { render, staticRenderFns } from "./InvitationOtherOfficeModal.vue?vue&type=template&id=65a962e1&lang=pug"
import script from "./InvitationOtherOfficeModal.vue?vue&type=script&lang=ts"
export * from "./InvitationOtherOfficeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports